var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1214 27.1477H24.0912H22.4673H22.1166V19.059H24.762C25.4329 19.059 25.8293 18.2967 25.4329 17.7478L20.287 10.6273C19.9592 10.1699 19.2807 10.1699 18.9528 10.6273L13.8069 17.7478C13.4105 18.2967 13.7993 19.059 14.4778 19.059H17.1232V27.1477H16.7725H15.1487H8.15781C4.15542 26.9266 0.96875 23.1834 0.96875 19.1276C0.96875 16.3298 2.48585 13.8902 4.73481 12.5713C4.52898 12.0148 4.42224 11.4202 4.42224 10.795C4.42224 7.93618 6.7322 5.62622 9.59105 5.62622C10.2086 5.62622 10.8032 5.73295 11.3597 5.93879C13.0141 2.43193 16.5819 0 20.7291 0C26.0962 0.00762361 30.5179 4.11675 31.021 9.35417C35.1454 10.0632 38.2787 13.8826 38.2787 18.2052C38.2787 22.8251 34.6803 26.8275 30.1214 27.1477Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.de9ff179ac92f421f38972de76245b18.svg";
export { ForwardRef as ReactComponent };